import { ExclamationTriangleIcon } from "@heroicons/react/24/solid";
import ContactAvatar from "../../contacts/ContactAvatar";
import ClickToCopy from "../../shared/ClickToCopy";
import Tooltip from "../../shared/Tooltip";
import { IContact } from './../../../models/Contact';
import { ILead } from "../../../models/Lead";
import { useMemo } from "react";

export default function TableVehicleContact({ contact, lead }: { contact: IContact | null, lead?: ILead | null }) {


  const accountDetailsComplete = useMemo(() => {
    return (!!contact?.account?.bankAccountName && !!contact?.account?.bankAccountNumber && !!contact?.account?.bankSortCode) ||
      (!!lead?.accountName && !!lead?.accountNumber && !!lead?.sortCode);
  }, [contact, lead])

  if (!contact || contact.fullname === "System No Contact") return (
    <div>
      <p>No Contact Found</p>
    </div>
  );

  return (
    <div className="flex gap-x-1 relative">
      <ContactAvatar contact={contact} />

      <div>
        <p className="font-semibold">{contact.fullname}</p>
        <ClickToCopy text={contact.telephone1} />
      </div>

      {!accountDetailsComplete && (
        <Tooltip content="Customer bank details incomplete">
          <ExclamationTriangleIcon className="w-6 h-6 text-yellow-400" />
        </Tooltip>
      )}
    </div>
  )
}